/**
 * workOrder.utils.js
 * ------------------
 * Utility functions for Work Orders UI and logic.
 */

/**
 * Get the display name of the assigned user.
 *
 * @param {Array} users - List of user objects with UserID, Name, and Lastname.
 * @param {string|number} userID - The ID of the user assigned to the work order.
 * @returns {string} Full name of the assigned user, or fallback if not found.
 */
export const getAssignedUserName = (users, userID) => {
  const user = users.find(u => String(u.UserID) === String(userID));
  return user ? `${user.Name} ${user.Lastname}` : `ID: ${userID}`;
};

/**
 * Get the work order type name by its ID.
 *
 * @param {Array} types - List of work order type objects.
 * @param {string|number} id - ID of the work order type.
 * @returns {string} Type name or "Unknown".
 */
export const getTypeName = (types, id) => {
  const type = types.find(t => String(t.id) === String(id));
  return type?.type || "Unknown";
};

/**
 * Get status information by status name.
 * This can include the color, icon name, and display label.
 *
 * @param {Array} statuses - List of status objects (with statusname, icon, color, etc.).
 * @param {string} statusName - Status name to look up.
 * @returns {Object} Status metadata or undefined if not found.
 */
export const getStatusInfo = (statuses, statusName) => {
  return statuses.find(s => s.statusname === statusName);
};
